export class LocaisModel {
  id_local: number;
  id_pais: number = 0;
  nome: string;
  sigla: string;
}



// WEBPACK FOOTER //
// ./src/app/locais/locais.model.ts